import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { isNullOrEmpty } from 'helpers/utils';
import type { User } from 'data/v1/data-contracts';

import ErrorBoundaryFallback from './ErrorBoundaryFallback';

Bugsnag.start({
  apiKey: process.env.BUGSNAG_JS_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
  onError(event) {
    const currentUser: User = window.gon.current_user_json;

    if (!isNullOrEmpty(currentUser)) {
      event.setUser(
        currentUser.id.toString(),
        currentUser.email_address,
        currentUser.full_name,
      );
    }
  },
});
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

type BugsnagErrorBoundaryProps = {
  disabled?: boolean;
  children: React.ReactNode;
};

const BugsnagErrorBoundary = ({
  disabled = false,
  children,
}: BugsnagErrorBoundaryProps) => {
  if (disabled) {
    return children;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default BugsnagErrorBoundary;
